module.exports = __webpack_public_path__ + "img/audits.a5b0dd62.svg";